import { alpha, Box, Paper, styled } from '@mui/material';
import PaperHeader from '../../components/PaperHeader';

export const Container = styled(Box)(({ theme }) => ({
    display: 'flex',
    height: '100%',
    padding: '24px',
    overflow: 'auto',

    [theme.breakpoints.down('md')]: {
        padding: '0',
    },

    [theme.breakpoints.down('sm')]: {
        padding: '0',
    },
    // '@media (min-width:1640px)': {
    //     maxWidth: '1640px',
    // },
}));
export const LeftBox = styled(Box)(({ theme }) => ({
    width: '60%',
    height: '100%',
    overflow: 'auto',
    minWidth: '30rem',
    padding: theme.typography.generic.xLarge,
    paddingRight: theme.typography.generic.xxxSmall,

    [theme.breakpoints.down('md')]: {
        width: '100%',
        padding: theme.typography.generic.xLarge,
    },

    [theme.breakpoints.down('sm')]: {
        minWidth: 'unset',

        width: '100%',
        padding: theme.typography.generic.xLarge,
    },
}));
export const IconBox = styled(Box)(({ theme }) => {
    return {
        paddingTop: `${theme.typography.generic.xSmall}`,
        paddingLeft: `${theme.typography.generic.xSmall}`,

        '& .MuiSvgIcon-root,& svg': {
            color: theme.palette.icon.brandPrimary,
            fontSize: '1.5rem',
        },
    };
});
export const DetailsIconBox = styled('div')(({ theme }) => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        borderRadius: theme.typography.borderRadius.small, // 10px
        color: alpha(theme.palette.common.darkCharcoal, 0.6),

        '& svg': {
            width: 24,
            height: 24,
        },
    };
});

export const DataTextBox = styled(Paper)(({ theme }) => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',

        width: '100%',
        padding: `${theme.typography.generic.xLarge} ${theme.typography.generic.xLarge}`,
        margin: `${theme.typography.generic.xxxxxLarge} ${theme.typography.generic.none}`,

        marginTop: '2rem',

        borderRadius: theme.typography.borderRadius.medium,
        border: `1px solid ${theme.palette.border.neutralPrimary}`,
        background: theme.palette.background.default,

        overflowX: 'auto',

        '& hr:last-of-type': {
            display: 'none',
        },

        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            rowGap: '1rem',

            '& hr:nth-of-type(2)': {
                display: 'none',
            },

            '& .item': {
                width: '42%',

                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
            },

            '& .item:nth-of-type(2n)': {
                width: '42%',
                rowGap: '1rem',

                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
            },
        },

        '@media (max-width:350px)': {
            flexWrap: 'wrap',
            rowGap: '1rem',

            '& hr': {
                display: 'none',
            },

            '& .item': {
                width: '100%',

                display: 'flex',
                justifyContent: 'flex-start',
            },

            '& .item:nth-of-type(2n)': {
                width: '100%',
                rowGap: '1rem',

                display: 'flex',
                justifyContent: 'flex-start',
            },
        },
    };
});

export const BusinessCustomListItemStyled = styled('li')(({ theme, isClicked }) => {
    return {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        borderRadius: theme.typography.borderRadius.xxxSmall,

        border: `1px solid ${isClicked ? theme.palette.border.brandPrimary : 'transparent'}`,

        padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.xSmall}`,

        cursor: 'pointer',

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    };
});

// Right Paper styles
export const CustomPaperHeader = styled(PaperHeader)(({ theme }) => {
    return {
        padding: `${theme.typography.generic.xxxLarge}`,

        '& .paper-heading': {
            fontSize: theme.typography.customFontSize.medium,
            lineHeight: theme.typography.customFontSize.xxLarge,
            fontWeight: theme.typography.fontWeightSemiBold,
        },

        // '& .icon-box': {
        //     color: theme.palette.text.statusWarning,
        //     backgroundColor: 'unset',
        // },
    };
});

export const UnorderList = styled('ul')(({ theme }) => ({
    listStyle: 'disc',
    listStylePosition: 'inside',
}));
export const UnorderListItem = styled('li')(({ theme }) => ({
    marginLeft: theme.typography.generic.xxxxxLarge,
    color: alpha(theme.palette.text.primary, 0.7),
    fontSize: theme.typography.customFontSize.small,
    fontWeight: `${theme.typography.fontWeightRegular}`,
    lineHeight: theme.typography.customFontSize.xxxLarge,
}));

export const OrderList = styled('ol')(({ theme }) => ({
    listStylePosition: 'inside',
}));
export const OrderListItem = styled('li')(({ theme }) => ({
    color: alpha(theme.palette.text.primary, 0.7),
    fontSize: theme.typography.customFontSize.small,
    fontWeight: theme.typography.fontWeightSemiBold,
    lineHeight: theme.typography.customFontSize.xxxLarge,
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
    listStyleType: 'none',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    flexDirection: 'column',

    marginTop: `-${theme.typography.generic.xSmall}`,
}));

// InfoBox
export const InfoBox = styled(Box)(({ theme }) => ({
    padding: `${theme.typography.generic.medium} ${theme.typography.generic.xSmall}`,
    background: theme.palette.brandSecondary[50],
    borderRadius: theme.typography.borderRadius.xxSmall,
    border: `1px solid ${theme.palette.info.main}`,
    color: theme.palette.info.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',

    marginTop: '1.875rem',
}));
